import * as React from 'react';

import './style.scss';

export default function NavigationErrorPage() {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    // Fallback to white logo if main logo fails
    const target = e.target as HTMLImageElement;
    if (target.src.includes('logo.png')) {
      target.src = '/assets/logo_white.png';
    } else if (target.src.includes('logo_white.png')) {
      // If both logos fail, hide the image
      target.style.display = 'none';
    }
  };

  return (
    <div className="navigation-error-page">
      <div className="navigation-error-page__container">
        <div className="navigation-error-page__logo">
          <img 
            src="/assets/logo.png" 
            alt="Comcate Logo" 
            onError={handleImageError}
          />
        </div>
        
        <div className="navigation-error-page__content">
          <h1 className="navigation-error-page__title">Something went wrong</h1>
          <p className="navigation-error-page__message">
            This session may have expired or the link is no longer valid. Please try again or return to the main page.
          </p>
        </div>
      </div>
    </div>
  );
} 